import { Fragment } from 'react';
import classNames from 'classnames';
import { asText, Content, isFilled } from '@prismicio/client';

import { RichText } from '@preventx/prismic-services';
import { Box, Link, Heading } from '@preventx/oxygen';

// Services
import { applicationEnv } from '@/services/env/shared';

// Components
import { BrandLogo } from '@/components/Graphics/BrandLogo';

type WithBrandsProps = {
  sliceId: string;
  slice: Content.RegionSliceWithBrands;
};

export const WithBrands = ({ sliceId, slice }: WithBrandsProps) => {
  const { primary } = slice;
  const { title, figures, caption, hide_title } = primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <>
      <Box
        component="div"
        className="headline align-center"
        addSROnly={hide_title && !isFilled.richText(caption)}
      >
        <Heading component="h2" addHeadlineTitle addSROnly={hide_title}>
          {asText(title)}
        </Heading>

        <RichText content={caption} variant="default" websiteUrl={WebsiteUrl} />
      </Box>

      <Box addCluster gap="gap-lg" component="div" className="justify-center">
        {(figures ?? []).map(({ logo, link, caption, hide_caption }, index) => {
          if (logo === null) {
            return null;
          }

          return (
            <Fragment key={`region-brands-${sliceId}-${index + 1}`}>
              {isFilled.link(link) && (
                <Link type="link-simple" as="default" href={link?.url ?? '#'}>
                  <Box component="figure">
                    <BrandLogo logo={logo} />

                    {isFilled.richText(caption) && (
                      <Box component="figcaption" addSROnly={hide_caption}>
                        <RichText
                          content={caption}
                          variant="default"
                          websiteUrl={WebsiteUrl}
                        />
                      </Box>
                    )}
                  </Box>
                </Link>
              )}

              {!isFilled.link(link) && (
                <Box component="figure">
                  <BrandLogo logo={logo} />

                  {isFilled.richText(caption) && (
                    <Box component="figcaption" addSROnly={hide_caption}>
                      <RichText
                        content={caption}
                        variant="default"
                        websiteUrl={WebsiteUrl}
                      />
                    </Box>
                  )}
                </Box>
              )}
            </Fragment>
          );
        })}
      </Box>
    </>
  );
};
